'use strict';

const getCookie = require('./getCookie');

const getCountryFromLocaleCookie = () => {
    const localeCookie = getCookie('_ritualsLocale');
    if (!localeCookie) {
        return '';
    }

    return localeCookie.split(/[||]/)[1];
};

module.exports = getCountryFromLocaleCookie;
